@if(trvMapService.isMapLoaded()) {
<div class="mobile-map-btn">
    <div class="current-icon first-item active-inner" (click)="menuOpen = !menuOpen">
        @if(getCurrentMobileMenuItem() != undefined && getCurrentMobileMenuItem().icon) {
        <app-svg-icon [svgIcon]="getCurrentMobileMenuItem().icon"></app-svg-icon>
        }
    </div>
    <div class="current-icon" (click)="eraser(undefined)">
        <app-svg-icon [svgIcon]="eraserIcon"></app-svg-icon>
    </div>
    <div class="toggle-icon" (click)="menuOpen = !menuOpen">
        @if(menuOpen) {
        <fa-icon [icon]="faArrowUp"></fa-icon>
        } @else {
        <fa-icon [icon]="faArrowDown"></fa-icon>

        }
    </div>
    @if(menuOpen){
    <div class="all-icons">
        @for (item of mobileMenuItems; track $index) { @if(item.condition == true) { @if(item.openModal) { 
        } @else {
        <div
            class="current-icon"
            [ngClass]="{ 'active-inner': item.mapTool == trvMapService.trvMap?.activeMapTool?.value }"
            (click)="clickIcon(item)"
        >
            <app-svg-icon [svgIcon]="item.icon"></app-svg-icon>
        </div>
        } } }
    </div>
    }
</div>
}
